import { useEffect } from 'react';
import APP_ITEMS from '../items/apps';
import { useDesktop, useLayoutSider } from '@/store';
import type { TItem } from '@/components/GridBoards/types';
import { createApp } from '../layoutItems';
import { getSiderXY, isInSider, isSiderRight } from '../doWithSider';

type ReturnOfUseSider = [TItem[], (arg: TItem[]) => void];

const useSiders = (siderbounds: LayoutBoxSiderbounds): ReturnOfUseSider => {
  const [sider, updateLayoutSider] = useLayoutSider();
  const [, updateDesktop] = useDesktop();

  useEffect(() => {
    updateDesktop({
      hotseatNum: sider?.length,
    });
  }, [sider, updateDesktop]);

  // 针对底部的sider，由于数组中的各项item是被反转过的，因此提供给页面渲染的数据，需要做一次反向的翻转
  // 数组中的数据会被反转的原因是设备端所需的数据差异导致：
  // 右侧sider(GXV3450/GXV3470) - 从上到下的索引是 4,3,2,1
  // 底部sider(GXV3470) - 从左到右的索引是 0,1,2,3
  const siderCopy = isSiderRight(siderbounds)
    ? sider?.slice()
    : sider?.slice().reverse();

  const result: TItem[] = (siderCopy || []).map<TItem>((a, i) => {
    return createApp(
      {
        className: a.className,
        y: a.y || i,
        x: a.x || i,
        ...getSiderXY(siderbounds),
      },
      siderbounds,
    );
  });

  const updateSiders = (items: TItem[]) => {
    /**
     *  x === col 的 都是sider
     */
    const tmp: PropType<ConfigLayout, 'sider'> = [];
    items
      .filter((i) => isInSider(i.x, i.y, siderbounds))
      // 数组中的元素排序规则： 右侧sider从上到下，底部sider从右到左(GXV3470的launcher数据要求)
      .sort((a, b) => (isSiderRight(siderbounds) ? a.y - b.y : b.x - a.x))
      .forEach((i) => {
        const _id = i.id as keyof typeof APP_ITEMS;
        if (APP_ITEMS[_id]) {
          tmp.push({
            className: _id,
            packageName: APP_ITEMS[_id].packageName,
          });
        }
      });

    updateLayoutSider(tmp);
  };

  return [result, updateSiders];
};

export default useSiders;
